<script setup lang="ts">
import { nl } from '@nuxt/ui-pro/locale'

const config = useRuntimeConfig()

if (config.public.aiAssistantEnabled) {
  // Add chatbot script to head
  useHead({
    script: [
      {
        src: 'https://fz2hpuko5djtcsgjdfn2q5nt.agents.do-ai.run/static/chatbot/widget.js',
        async: true,
        'data-agent-id': '64922cf2-67ed-11f0-bf8f-4e013e2ddde4',
        'data-chatbot-id': 'wfbhL1Gd18OeKFwn50fOucyQI0MpbsJr',
        'data-name': 'C5P assistent',
        'data-primary-color': '#F1F1F1',
        'data-secondary-color': '#E5E8ED',
        'data-button-background-color': '#ffffff',
        'data-starting-message': 'C5P assistent vraagt om hulp',
        'data-logo':
          'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTm1ax5ar-XE4ozYQwsRwz31S2j6StNKYcEbQ&s',
      },
    ],
  })
}
</script>

<template>
  <UApp :locale="nl">
    <NuxtLoadingIndicator />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
